<mx-base-form-field [fieldName]="fieldName" [overrideLabel]="overrideLabel" [externalLabel]="externalLabel" [uppercaseExternalLabel]="uppercaseExternalLabel"
                    [formGroup]="formGroup" [control]="control" [focused]="focused" [enabled]="enabled" [hintLabel]="hintLabel"
                    [showValidationErrors]="showValidationErrors" matAutocompleteOrigin #autoCompleteOrigin="matAutocompleteOrigin">
  @if (includeSearchIcon) {
    <mat-icon class="mat-icon-size-6 me-3 text-on-surface">search</mat-icon>
  }

  @if (includeDollarSign) {
    <span class="mx-form-field-text-prefix text-label-large me-3 text-on-surface">$</span>
  }

  <input #inputElement matInput [type]="inputType" [formControl]="control" [placeholder]="placeholder" [attr.maxlength]="maxLength ?? null"
         [attr.inputmode]="inputMode ?? null"
         [errorStateMatcher]="validationErrorStateMatcher"
         [matAutocomplete]="autocompleteElement" [matAutocompleteDisabled]="!autocompleteElement" [matAutocompleteConnectedTo]="autoCompleteOrigin"
         (focus)="onFocusInput()" (blur)="onBlurInput()" (keydown.enter)="onKeydownEnter()"
         [class.text-right]="alignRight" class="input-form-field grow w-full" [autocomplete]="overrideBrowserAutocomplete ?? 'off'"
         [attr.data-lpignore]="overrideBrowserAutocomplete ? 'true' : null"
         [attr.data-dashlane-rid]="overrideBrowserAutocomplete ? 'card-block' : null"
         [attr.data-1p-ignore]="overrideBrowserAutocomplete ? 'true' : null"/>

  @if (postfixText) {
    <span>&nbsp;{{ postfixText }}</span>
  }

  @if (showClearButton) {
    <mx-icon-button icon="clear" [customContentTemplate]="(replaceClearButtonWithSpinner | select) ? clearButtonSpinner : undefined"
                    (mousedown)="$event.preventDefault()" (click)="onClickClearButton()"/>
  }

  @if (showAuxiliaryButton) {
    <mx-icon-button [icon]="auxiliaryButtonIconName" [iconClasses]="auxiliaryButtonIconClass" [tooltip]="auxiliaryButtonTooltip"
                    (mousedown)="$event.preventDefault()" (click)="onClickAuxiliaryButton()"/>
  }
</mx-base-form-field>

<ng-template #clearButtonSpinner>
  <mat-spinner [diameter]="24"/>
</ng-template>
